import { Card } from "../components/Card";
import { Spinner } from "../components/Spinner";
import { cn } from "../lib/utils";
import * as React from "react";
const Root = ({ className, children }) => (React.createElement(Card, { size: "md", className: cn("s-flex s-flex-col s-gap-2", className) }, children));
const Header = ({ className, children }) => (React.createElement("div", { className: cn("s-space-y-0.5", className) }, children));
const Title = ({ className, children }) => (React.createElement("div", { className: cn("s-heading-sm", "s-text-foreground dark:s-text-foreground-night", className) }, children));
const Subtitle = ({ className, children }) => (React.createElement("div", { className: cn("s-text-sm", "s-text-muted-foreground dark:s-text-muted-foreground-night", className) }, children));
const Content = ({ className, children, isLoading = false, }) => {
    if (isLoading) {
        return (React.createElement("div", { className: "s-flex s-items-center s-justify-start" },
            React.createElement(Spinner, { size: "xs", variant: "dark" })));
    }
    return (React.createElement("div", { className: cn("s-flex s-flex-col s-gap-3", "s-text-foreground dark:s-text-foreground-night", className) }, children));
};
const Footer = ({ className, children }) => (React.createElement("div", { className: cn("s-flex s-items-center s-gap-2", className) }, children));
export const ValueCard = ({ title, subtitle, content, footer, isLoading = false, className, }) => {
    return (React.createElement(Root, { className: className },
        React.createElement(Header, null,
            React.createElement(Title, null, title),
            subtitle && React.createElement(Subtitle, null, subtitle)),
        React.createElement(Content, { isLoading: isLoading }, content),
        footer && React.createElement(Footer, null, footer)));
};
export const ComposableCard = {
    Root,
    Header,
    Title,
    Subtitle,
    Content,
    Footer,
};
//# sourceMappingURL=ValueCard.js.map